import { render, staticRenderFns } from "./NotificationsManager.vue?vue&type=template&id=ee863912&"
import script from "./NotificationsManager.vue?vue&type=script&lang=js&"
export * from "./NotificationsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports